export default "https://static.zego.com/_next/static/chunks/fonts/ModernEra-Black-4b05b10621c339a09fa6f7fb9d0e643b.woff";